export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-03.59884e25.jpg";